import { OnInit } from '@angular/core';
import * as jspdf from 'jspdf';
import html2canvas from 'html2canvas';
import { GLOBAL } from 'src/app/services/global';
var Formulario23Component = /** @class */ (function () {
    function Formulario23Component() {
        this.htmlcanvas = html2canvas;
        this.nombreMuni = GLOBAL.nombreMuni;
        this.region = GLOBAL.region;
        //listas filtros
        this.perm = [];
        this.recep = [];
        this.pages = [1, 2, 3];
        //PERMISOS RECEPCION
        if (JSON.parse(localStorage.getItem("permisos_recep")).length > 0) {
            this.permisos_recep = JSON.parse(localStorage.getItem("permisos_recep"));
        }
        else {
            localStorage.setItem("permisos_recep", JSON.stringify([]));
            this.permisos_recep = [{ tipo_permiso: '', permiso: '', numero: null, fecha: null, superficie: null, recepcion: '', fecha_recep: null }];
        }
        if (this.permisos_recep.length > 0) {
            for (var i = 0; i < this.permisos_recep.length; i++) {
                if (this.permisos_recep[i].tipo_permiso == "Permiso Primitivo") {
                    this.perm.push(this.permisos_recep[i]);
                }
                else if (this.perm.length == 0 && this.permisos_recep.length == (i + 1)) {
                    this.perm = [{ tipo_permiso: '', permiso: '', numero: null, fecha: null, superficie: null, recepcion: '', fecha_recep: null }];
                }
                if (this.permisos_recep[i].tipo_permiso == "Ampliaciones") {
                    this.recep.push(this.permisos_recep[i]);
                }
                else if (this.recep.length == 0 && this.permisos_recep.length == (i + 1)) {
                    this.recep = [{ tipo_permiso: '', permiso: '', numero: null, fecha: null, superficie: null, recepcion: '', fecha_recep: null },
                        { tipo_permiso: '', permiso: '', numero: null, fecha: null, superficie: null, recepcion: '', fecha_recep: null }];
                }
            }
            if (this.recep.length > 0 && this.recep.length < 5) {
                for (var x = this.recep.length; x < 3; x++) {
                    this.recep.push({ tipo_permiso: '', permiso: '', numero: null, fecha: null, superficie: null, recepcion: '', fecha_recep: null });
                }
            }
        }
        else {
            this.perm = [{ tipo_permiso: '', permiso: '', numero: null, fecha: null, superficie: null, recepcion: '', fecha_recep: null }];
            this.recep = [{ tipo_permiso: '', permiso: '', numero: null, fecha: null, superficie: null, recepcion: '', fecha_recep: null },
                { tipo_permiso: '', permiso: '', numero: null, fecha: null, superficie: null, recepcion: '', fecha_recep: null }];
        }
    }
    Formulario23Component.prototype.ngAfterContentChecked = function () {
        this.ngAfterContentInit();
    };
    Formulario23Component.prototype.ngOnInit = function () {
    };
    Formulario23Component.prototype.ngAfterContentInit = function () {
        //tipo permiso
        if (JSON.parse(localStorage.getItem("tipo_permiso"))) {
            if (JSON.parse(localStorage.getItem("tipo_permiso")).length > 0) {
                this.tipo_permiso = JSON.parse(localStorage.getItem("tipo_permiso"));
            }
            else {
                localStorage.setItem("tipo_permiso", JSON.stringify([]));
                this.tipo_permiso = [{ obra: '', loteo_dfl: '', loteo_const: '', ampliacion: '', alteracion: '', reparacion: '', reconstruccion: '' }];
            }
        }
        //CIP
        if (JSON.parse(localStorage.getItem("cip"))) {
            if (JSON.parse(localStorage.getItem("cip")).length > 0) {
                this.cip = JSON.parse(localStorage.getItem("cip"));
            }
            else {
                localStorage.setItem("cip", JSON.stringify([]));
                this.cip = [{ certcip: '', fecha_cip: null }];
            }
        }
        //REGISTRO
        if (JSON.parse(localStorage.getItem("registro_bienes"))) {
            if (JSON.parse(localStorage.getItem("registro_bienes")).length > 0) {
                this.registro_bienes = JSON.parse(localStorage.getItem("registro_bienes"));
            }
            else {
                localStorage.setItem("registro_bienes", JSON.stringify([]));
                this.registro_bienes = [{ inscrito: '', numero: '', anio: '', bienes: '' }];
            }
        }
        //PROPIEDAD
        if (JSON.parse(localStorage.getItem("propiedad"))) {
            if (JSON.parse(localStorage.getItem("propiedad")).length > 0) {
                this.propiedad = JSON.parse(localStorage.getItem("propiedad"));
            }
            else {
                localStorage.setItem("propiedad", JSON.stringify([]));
                this.propiedad = [{ rol: '', id_direcc: '', folio: '', calle: '', calle_num: 0, direccion_completa: '', direc_complemento: '', direc_compl_num: '', loteo: '', manzana: '', plano: '', recordId: '' }];
            }
        }
        //PROPIETARIOS
        if (JSON.parse(localStorage.getItem("propietarios"))) {
            if (JSON.parse(localStorage.getItem("propietarios")).length > 0) {
                this.propietarios = JSON.parse(localStorage.getItem("propietarios"));
            }
            else {
                localStorage.setItem("propietarios", JSON.stringify([]));
                this.propietarios = [{ rut: '', nombre: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', fax: '', mail: '', recordId: '' }];
            }
        }
        //REPRESENTANTE
        if (JSON.parse(localStorage.getItem("representantes"))) {
            if (JSON.parse(localStorage.getItem("representantes")).length > 0) {
                this.representantes = JSON.parse(localStorage.getItem("representantes")); //no es obligatorio pero si tiene informacion debe estar permiso_notariado obligatoriamente
            }
            else {
                localStorage.setItem("representantes", JSON.stringify([]));
                this.representantes = [{ rut: '', nombre: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', fax: '', mail: '', recordId: '' }];
            }
        }
        //PERMISO NOTARIADO
        if (JSON.parse(localStorage.getItem("permiso_notariado"))) {
            if (JSON.parse(localStorage.getItem("permiso_notariado")).length > 0) {
                this.permiso_notariado = JSON.parse(localStorage.getItem("permiso_notariado"));
            }
            else {
                localStorage.setItem("permiso_notariado", JSON.stringify([]));
                this.permiso_notariado = [{ acreditacion: '', fecha: null, escritura: null, notario: '' }];
            }
        }
        //EMPRESAS
        if (JSON.parse(localStorage.getItem("empresas"))) {
            if (JSON.parse(localStorage.getItem("empresas")).length > 0) {
                this.empresas = JSON.parse(localStorage.getItem("empresas"));
            }
            else {
                localStorage.setItem("empresas", JSON.stringify([]));
                this.empresas = [{ rut: '', nombre: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', fax: '', mail: '', recordId: '' }];
            }
        }
        //ARQUITECTOS
        if (JSON.parse(localStorage.getItem("arquitectos"))) {
            if (JSON.parse(localStorage.getItem("arquitectos")).length > 0) {
                this.arquitectos = JSON.parse(localStorage.getItem("arquitectos"));
            }
            else {
                localStorage.setItem("arquitectos", JSON.stringify([]));
                this.arquitectos = [{ rut: '', nombre: '', mail: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_complemento: '', direccion_num: '', comuna: '', fono: '', fax: '', patente: '', recordId: '' }];
            }
        }
        //CONSTRUCTORES 
        if (JSON.parse(localStorage.getItem("constructores"))) {
            if (JSON.parse(localStorage.getItem("constructores")).length > 0) {
                this.constructores = JSON.parse(localStorage.getItem("constructores"));
            }
            else {
                localStorage.setItem("constructores", JSON.stringify([]));
                this.constructores = [{ rut: '', nombre: '', mail: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_complemento: '', direccion_num: '', comuna: '', fono: '', fax: '', patente: '', recordId: '' }];
            }
        }
        //INDEPENDIENTE
        if (JSON.parse(localStorage.getItem("independiente"))) {
            if (JSON.parse(localStorage.getItem("independiente")).length > 0) {
                this.independiente = JSON.parse(localStorage.getItem("independiente")); //no es obligatorio pero si tiene informacion debe estar permiso_notariado obligatoriamente
            }
            else {
                localStorage.setItem("independiente", JSON.stringify([]));
                this.independiente = [{ rut: '', nombre: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', fax: '', mail: '', patente: '', registro: '', categoria: '', recordId: '' }];
            }
        }
        //INFORME
        if (JSON.parse(localStorage.getItem("informe"))) {
            if (JSON.parse(localStorage.getItem("informe")).length > 0) {
                this.informe = JSON.parse(localStorage.getItem("informe"));
            }
            else {
                localStorage.setItem("informe", JSON.stringify([]));
                this.informe = [{ infradio: '', num_informe: '', fech_informe: '' }];
            }
        }
        //CALCULISTA
        if (JSON.parse(localStorage.getItem("calculistas"))) {
            if (JSON.parse(localStorage.getItem("calculistas")).length > 0) {
                this.calculistas = JSON.parse(localStorage.getItem("calculistas")); //no es obligatorio pero si tiene informacion debe estar permiso_notariado obligatoriamente
            }
            else {
                localStorage.setItem("calculistas", JSON.stringify([]));
                this.calculistas = [{ rut: '', nombre: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', fax: '', mail: '', recordId: '' }];
            }
        }
        //INFORME REVISOR
        if (JSON.parse(localStorage.getItem("informe_revisor"))) {
            if (JSON.parse(localStorage.getItem("informe_revisor")).length > 0) {
                this.informe_revisor = JSON.parse(localStorage.getItem("informe_revisor"));
            }
            else {
                localStorage.setItem("informe_revisor", JSON.stringify([]));
                this.informe_revisor = [{ infradio: '', num_informe: '', fech_informe: '' }];
            }
        }
        //SUPERFICIE
        if (JSON.parse(localStorage.getItem("superficie_anteproyecto"))) {
            if (JSON.parse(localStorage.getItem("superficie_anteproyecto")).length > 0) {
                this.superficie_anteproyecto = JSON.parse(localStorage.getItem("superficie_anteproyecto"));
            }
            else {
                localStorage.setItem("superficie_anteproyecto", JSON.stringify([]));
                this.superficie_anteproyecto = [{ util1: '', comun1: '', total1: '', util2: '', comun2: '', total2: '', util3: '', comun3: '', total3: '', totalt: '' }];
            }
        }
        //UNIDADES
        if (JSON.parse(localStorage.getItem("unidades"))) {
            if (JSON.parse(localStorage.getItem("unidades")).length > 0) {
                this.unidades = JSON.parse(localStorage.getItem("unidades"));
            }
            else {
                localStorage.setItem("unidades", JSON.stringify([]));
                this.unidades = [{ vivienda: '', oficinas: '', locales: '', estacionamientos: '', otros: '' }];
            }
        }
        //PERMISOS RECEPCION
        if (localStorage.getItem("permisos_recep")) {
            if (JSON.parse(localStorage.getItem("permisos_recep")).length > 0) {
                this.permisos_recep = JSON.parse(localStorage.getItem("permisos_recep"));
            }
            else {
                localStorage.setItem("permisos_recep", JSON.stringify([]));
                this.permisos_recep = [{ tipo_permiso: '', permiso: '', numero: null, fecha: null, superficie: null, recepcion: '', fecha_recep: null }];
            }
        }
        //DISPOSICIONES ESPECIALES
        if (JSON.parse(localStorage.getItem("disposiciones_esp"))) {
            if (JSON.parse(localStorage.getItem("disposiciones_esp")).length > 0) {
                this.disposiciones_esp = JSON.parse(localStorage.getItem("disposiciones_esp"));
            }
            else {
                localStorage.setItem("disposiciones_esp", JSON.stringify([]));
                this.disposiciones_esp = [{ disposicion1: '', disposicion2: '', disposicion3: '', disposicion4: '', disposicion5: '', disposicion6: '', disposicion7: '', disposicion8: '' }];
            }
        }
        //CLASIFICACION
        if (JSON.parse(localStorage.getItem("clasificacion"))) {
            if (JSON.parse(localStorage.getItem("clasificacion")).length > 0) {
                this.clasificacion = JSON.parse(localStorage.getItem("clasificacion"));
            }
            else {
                localStorage.setItem("clasificacion", JSON.stringify([]));
                this.clasificacion = [{ clasificacion: '', metro: '' }];
            }
        }
        //DESTINO
        if (JSON.parse(localStorage.getItem("destino"))) {
            if (JSON.parse(localStorage.getItem("destino")).length > 0) {
                this.destino = JSON.parse(localStorage.getItem("destino"));
            }
            else {
                localStorage.setItem("destino", JSON.stringify([]));
                this.destino = [{ residencial: '', destino_resd: '', equipamiento: '', clase_eq: '', actividad_eq: '', escala_eq: '', actividad: '', destino_act: '', infraestructura: '', destino_infr: '', otros: '', esp_otros: '' }];
            }
        }
        //NORMAS URBANISTICAS
        if (JSON.parse(localStorage.getItem("normas_urbanisticas"))) {
            if (JSON.parse(localStorage.getItem("normas_urbanisticas")).length > 0) {
                this.normas_urbanisticas = JSON.parse(localStorage.getItem("normas_urbanisticas"));
            }
            else {
                localStorage.setItem("normas_urbanisticas", JSON.stringify([]));
                this.normas_urbanisticas = [{ constr_perm: '', constr_proy: '', ocup_perm: '', ocup_proy: '', alt_perm: '', alt_proy: '', rasant_perm: '', rasant_proy: '', dist_perm: '', dist_proy: '', suelo_perm: '', suelo_proy: '', densid_perm: '', densid_proy: '', adosam_perm: '', adosam_proy: '', antej_perm: '', antej_proy: '', est_req: '', est_proy: '' }];
            }
        }
        //CLASIFICACION CONSTRUCCION PREDOMINANTE
        if (JSON.parse(localStorage.getItem("clasificacion"))) {
            if (JSON.parse(localStorage.getItem("clasificacion")).length > 0) {
                this.clasificacion = JSON.parse(localStorage.getItem("clasificacion"));
            }
            else {
                localStorage.setItem("clasificacion", JSON.stringify([]));
                this.clasificacion = [{ clasificacion: "", metro: "" }];
            }
        }
        //UNIDADES TOTALES POR DESTINO
        if (JSON.parse(localStorage.getItem("unidades"))) {
            if (JSON.parse(localStorage.getItem("unidades")).length > 0) {
                this.unidades = JSON.parse(localStorage.getItem("unidades"));
            }
            else {
                localStorage.setItem("unidades", JSON.stringify([]));
                this.unidades = [{ vivienda: '', oficinas: '', locales: '', estacionamientos: '', otros: '' }];
            }
        }
        //DISPOSICIONES ESPECIALES
        if (JSON.parse(localStorage.getItem("disposiciones_esp"))) {
            if (JSON.parse(localStorage.getItem("disposiciones_esp")).length > 0) {
                this.disposiciones_esp = JSON.parse(localStorage.getItem("disposiciones_esp"));
            }
            else {
                localStorage.setItem("disposiciones_esp", JSON.stringify([]));
                this.disposiciones_esp = [{ disposicion1: '', disposicion2: '', disposicion3: '', disposicion4: '', disposicion5: '', disposicion6: '', disposicion7: '', disposicion8: '' }];
            }
        }
        //AUTORIZACIONES ESPECIALES LGUC
        if (JSON.parse(localStorage.getItem("autorizaciones"))) {
            if (JSON.parse(localStorage.getItem("autorizaciones")).length > 0) {
                this.autorizaciones = JSON.parse(localStorage.getItem("autorizaciones"));
            }
            else {
                localStorage.setItem("autorizaciones", JSON.stringify([]));
                this.autorizaciones = [{ Art121: '', Art122: '', Art123: '', Art124: '', Ley19537: '', Otro: '' }];
            }
        }
        //OTRAS SOLICITUDES
        if (JSON.parse(localStorage.getItem("otras_solicitudes"))) {
            if (JSON.parse(localStorage.getItem("otras_solicitudes")).length > 0) {
                this.otras_solicitudes = JSON.parse(localStorage.getItem("otras_solicitudes"));
            }
            else {
                localStorage.setItem("otras_solicitudes", JSON.stringify([]));
                this.otras_solicitudes = [{ tramitacion_conj1: '', tramitacion_conj2: '', tramitacion_conj3: '', tramitacion_conj4: '', fusion: '', solicitud_fusion: '', fecha_fusion: '', cambio: '', solicitud_cambio: '', fecha_cambio: '', otras: '', loteo: '', solicitud_loteo: '', fecha_loteo: '' }];
            }
        }
        //DECLARACION
        if (JSON.parse(localStorage.getItem("declaracion"))) {
            if (JSON.parse(localStorage.getItem("declaracion")).length > 0) {
                this.declaracion = JSON.parse(localStorage.getItem("declaracion"));
            }
            else {
                localStorage.setItem("declaracion", JSON.stringify([]));
                this.declaracion = [{ plano: '', denominado: '', elaborado: '', profesion: '' }];
            }
        }
        //REVISOR
        if (JSON.parse(localStorage.getItem("revisor"))) {
            if (JSON.parse(localStorage.getItem("revisor")).length > 0) {
                this.revisor = JSON.parse(localStorage.getItem("revisor"));
            }
            else {
                localStorage.setItem("revisor", JSON.stringify([]));
                this.revisor = [{ rut: '', nombre: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', fax: '', mail: '', patente: '', recordId: '' }];
            }
        }
        //Caracteristicas de anteproyecto    
        if (JSON.parse(localStorage.getItem("caract_anteproyecto"))) {
            if (JSON.parse(localStorage.getItem("caract_anteproyecto")).length > 0) {
                this.caract_anteproyecto = JSON.parse(localStorage.getItem("caract_anteproyecto"));
            }
            else {
                localStorage.setItem("caract_anteproyecto", JSON.stringify([]));
                this.caract_anteproyecto = [{ uso_publico: '', anteproy_aprob: '', numero: '', fecha: null }];
            }
        }
    };
    Formulario23Component.prototype.captureScreen = function () {
        var _this = this;
        var pdf = new jspdf('p', 'mm', 'a4');
        this.htmlcanvas(document.getElementById("page1")).then(function (canvas) {
            var contentDataURL = canvas.toDataURL('image/png');
            pdf.addImage(contentDataURL, 'PNG', 5, 5, 200, 297);
        });
        this.htmlcanvas(document.getElementById("page2")).then(function (canvas) {
            var contentDataURL = canvas.toDataURL('image/png');
            pdf.addPage();
            pdf.addImage(contentDataURL, 'PNG', 5, 5, 200, 297);
        });
        this.htmlcanvas(document.getElementById("page3")).then(function (canvas) {
            var contentDataURL = canvas.toDataURL('image/png');
            pdf.addPage();
            pdf.addImage(contentDataURL, 'PNG', 5, 5, 200, 297);
        });
        this.htmlcanvas(document.getElementById("page4")).then(function (canvas) {
            var contentDataURL = canvas.toDataURL('image/png');
            pdf.addPage();
            pdf.addImage(contentDataURL, 'PNG', 5, 5, 200, 297);
        });
        this.htmlcanvas(document.getElementById("page5")).then(function (canvas) {
            var contentDataURL = canvas.toDataURL('image/png');
            pdf.addPage();
            pdf.addImage(contentDataURL, 'PNG', 5, 5, 200, 297);
        });
        setTimeout(function () {
            pdf.save(_this.propietarios[0].rut + '.pdf');
            // pdf.save('prueba.pdf')
        }, 6000);
    };
    return Formulario23Component;
}());
export { Formulario23Component };
